import { createContext, useContext } from "react";

import type { FieldsetVariant } from "./Fieldset.types";

export type FieldsetContextValue = {
  variant: FieldsetVariant;
  collapsible: boolean;
};

export function makeFieldsetContext({
  variant = "plain",
  collapsible = false,
}: Partial<FieldsetContextValue>): FieldsetContextValue {
  return { variant, collapsible };
}

export const FieldsetContext = createContext<FieldsetContextValue>(
  makeFieldsetContext({}),
);

export function useFieldsetContext() {
  return useContext(FieldsetContext);
}
